import type { IGetMarketsByEventIdRequestParams } from "~/feature/dashboard/types";
import { MarketGroupRankEnum, MarketSortByEnum } from "~/types/event";
import { SortOrderEnum } from "~/types/sort";

export const DEFAULT_MARKETS_SORT_PARAMS: Pick<
  IGetMarketsByEventIdRequestParams,
  "sortBy" | "sortOrder"
> = {
  sortBy: MarketSortByEnum.CHANCE,
  sortOrder: SortOrderEnum.DESC,
};

/**
 * Every markets query this page makes carries it (PH-1116): a group of matched markets is ranked by
 * the consensus % chance its own group row shows, not by its best single market. The dashboard's
 * expanded panel asks for `groupRank=outcome` instead (PH-1359, `useDashboardPanelData.ts`).
 * Ordering is server-side and paginated, so the grid cannot re-rank what it receives.
 */
export const MARKETS_GROUP_RANK_PARAMS: Pick<
  IGetMarketsByEventIdRequestParams,
  "groupRank"
> = {
  groupRank: MarketGroupRankEnum.CONSENSUS,
};

export enum EventPageSections {
  EventHeader = "market-overview",
  EventChart = "market-chart",
  MarketCalculator = "market-calculator",
  MarketsTabs = "market-table",
  MarketDescription = "market-description",
  OfficialRules = "official-rules",
  Intro = "intro",
  RDA = "rda",
  FAQ = "faqs",
  RelatedNews = "related-news",
  RelatedEvents = "related-events",
}
